import { render, staticRenderFns } from "./VgtGlobalSearch.vue?vue&type=template&id=1b167c32"
import script from "./VgtGlobalSearch.vue?vue&type=script&lang=js"
export * from "./VgtGlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports